__turbopack_context__.v({
  "buttonRow": "zVr-7W_buttonRow",
  "description": "zVr-7W_description",
  "header": "zVr-7W_header",
  "paymentSuccess": "zVr-7W_paymentSuccess",
  "permissionsModal": "zVr-7W_permissionsModal",
  "permissionsModalContent": "zVr-7W_permissionsModalContent",
  "validationError": "zVr-7W_validationError",
});
